import type { FC, ReactElement } from 'react';

import { useToastSlice } from '../../store/slices/toast/selectors';

import { ToastRenderer } from './ToastRenderer';
import { ToastConfig } from './types';

import style from './ToastContainerConnected.module.css';

export const ToastContainerConnected: FC<{ gameToastConfig?: ToastConfig }> = ({ gameToastConfig }): ReactElement => {
  const toasts = useToastSlice.getToasts();
  return (
    <div className={style.toastContainerConnected}>
      {toasts.map((toast) => (
        <ToastRenderer {...toast} key={toast.timeStamp} additionalToastConfig={gameToastConfig} />
      ))}
    </div>
  );
};
